const isQAEnv = window.location.origin === "https://qatalenthub.dweb.in" || window.location.origin === "http://localhost:3000";

export const RoleGroups = isQAEnv
  ? {
    Admin: "f3997382-e9e2-4ba3-9704-15336a8e760f", // qa
    Interviewer: "51c4a1c1-71d8-482d-8f8b-69f1e62fa637", // qa
  }
  : {
    Admin: "51c4a1c1-71d8-482d-8f8b-69f1e62fa637", // prod
    Interviewer: "f3997382-e9e2-4ba3-9704-15336a8e760f", // prod
  };
